import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPenToSquare, faTrash, faBackward, faForward } from "@fortawesome/free-solid-svg-icons";
import EditDialog from "./EditDialog";
import axiosInstance from "../../interceptor/axiosInstance";
import { formatTime } from "../Utils/UtilityService";



const KnowledgeFeedback = () => {
  const [feedbackAnswers, setFeedbackAnswers] = useState([]);
  const [editDialog, setEditDialog] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [feedbackFilter, setFeedbackFilter] = useState("all");
  const [page, setPage] = useState(1);
  const pageSize = 25;

   useEffect(() => {
    fetchFeedbackAnswers();
    }, []);

 const fetchFeedbackAnswers = async () => {
  try {
    const response = await axiosInstance.get(`/org/feedback/pending`);
    const data = response.data;
    console.log(data)

    setFeedbackAnswers(data);
  } catch (error) {
    console.error("Error fetching feedback answers:", error);
  }
};
  
  const deleteFeedback = async(id)=> {
    const payload = {
      messageId: id
    }
    try {
      await axiosInstance.post(
      '/org/feedback/delete', 
      payload, 
      {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      fetchFeedbackAnswers();
    } catch(err) {
      console.log(err)
    }
  };

  const filteredFeedback = feedbackAnswers.filter(item => {
    const created = new Date(item.createdAt);
    const matchDate =
        (!dateFrom || created >= new Date(dateFrom)) &&
        (!dateTo || created <= new Date(dateTo));

      // Filter by feedback presence
      const hasFeedback = item.feedbackAnswer && item.feedbackAnswer.trim() !== "";
      const matchFeedback =
        feedbackFilter === "present" ? hasFeedback
        : feedbackFilter === "absent" ? !hasFeedback
        : true;

  return matchDate && matchFeedback;
});

    const totalPages = Math.ceil(filteredFeedback.length / pageSize);

    const start = (page - 1) * pageSize;
    const end = start + pageSize;
    const currentData = filteredFeedback.slice(start, end);

  return(    
    <>
      <div className="agent-container hero-section text-center mb-4" style={styles.heroSection}>
        <h3 className="heading-large">Improve Your Assistant with Feedback</h3>
        <p className="conv-content" style={{marginBottom: "5px"}}>
          Review chatbot answers and share your feedback to help improve the knowledge base for each question.
        </p>        
      </div>

      {/* Disliked Answers Table */}
      <div className="agent-container">
        <div style={{ marginBottom: "16px", display: "flex", gap: "20px", alignItems: "center" }}>
    <div>
    <label>From: </label>
    <input
      type="date"
      value={dateFrom}
      onChange={(e) => setDateFrom(e.target.value)}
      style={{borderRadius:"8px", marginLeft: "5px"}}
    />
  </div>

  <div>
    <label>To: </label>
    <input
      type="date"
      value={dateTo}
      onChange={(e) => setDateTo(e.target.value)}
      style={{borderRadius:"8px", marginLeft: "5px"}}
    />
  </div>
    <div style={{marginLeft:"50px"}}>
      <label>Feedback:</label>
      <select
        value={feedbackFilter}
        onChange={(e) => setFeedbackFilter(e.target.value)}
        style={{borderRadius:"8px", marginLeft: "5px", border: "2px solid #000",}}
      >
        <option value="all">All</option>
        <option value="present">Answered</option>
        <option value="absent">No Feedback</option>
      </select>
    </div>
  </div>
      <div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr className="tbl-header-color conv-user">
              <th style={{ ...styles.headerCell, width: "50px" }}>No.</th>
              <th style={{ ...styles.headerCell, width: "150px" }}>Time</th>
              <th style={styles.headerCell}>Disliked Messages</th>
              <th style={{...styles.headerCell, width: "400px"}}>Feedback</th>
              <th style={{ ...styles.headerCell, width: "120px" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredFeedback  && filteredFeedback.length > 0 ? (
              currentData.map((item, index) => (
                <React.Fragment key={item.id}>
                  <tr style={styles.row} className="conv-content">
                    {/* Numbering */}
                    <td style={styles.cell}>{index + 1}</td>
                    <td style={styles.cell}>{formatTime(item.createdAt)}</td>
                    {/* Min 50 char preview */}
                    <td style={styles.cell}>
                       <div>
                        <span style={{ color: "black", fontWeight: "bold" }}>
                          {item.question?.length>300 
                            ? item.question.substring(0, 300) + "..."
                            : item.question
                          }
                        </span>
                        <br />
                        <span>{item.answer?.length>300
                          ? item.answer.substring(0,300) + "..."
                          : item.answer
                          }</span>
                      </div>
                    </td>
                    <td style={styles.cell}>
                         <div style={{ marginTop: "2px" }}>
                            <span style={{ color: "black", fontWeight: "bold" }}>
                              {item.feedbackQuestion?.length>300
                          ? item.feedbackQuestion.substring(0,300) + "..."
                          : item.feedbackQuestion
                          }
                            </span>
                            <br />
                            <span>
                              {item.feedbackAnswer?.length>300
                          ? item.feedbackAnswer.substring(0,300) + "..."
                          : item.feedbackAnswer
                          }
                            </span>
                          </div>
                    </td>
                    {/* Action Buttons */}
                    <td style={{ ...styles.cell, textAlign: "center", width: "170px" }}>                      
                      <button
                        className="btn"
                        style={{
                          marginRight: "8px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "36px",  // same height/width as normal button
                          height: "36px",
                          padding: "0",
                          // color: "#ffffff",
                          // backgroundColor: "cadetblue",
                        }}
                          onClick={()=> window.open(`/chat?chatId=${item.threadId}`)}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                      <button 
                        className="btn"
                        style={{
                            marginRight: "8px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "36px",  // same height/width as normal button
                            height: "36px",
                            padding: "0",
                            // color: "#ffffff",
                            // backgroundColor: "cadetblue",
                          }}
                      onClick={() => {setSelectedMessage(item); setEditDialog(true)}} ><FontAwesomeIcon icon={faPenToSquare}/></button>
                     <button 
                        className="btn"
                        style={{
                            marginRight: "8px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "36px",  // same height/width as normal button
                            height: "36px",
                            padding: "0",
                          }}
                      onClick={() => deleteFeedback(item.messageId)} ><FontAwesomeIcon icon={faTrash}/></button>
                    </td>
                  </tr>             
                </React.Fragment>
                
              ))
            ) : (
              <tr>
                <td style={styles.noRecordCell} colSpan="3">
                  No disliked answers available!
                </td>
              </tr>
            )}
          </tbody>
          {selectedMessage && (
                    <EditDialog
                        open={editDialog}
                        onClose={() => setEditDialog(false)}
                        onSave={() => {
                          console.log("Saved changes for", selectedMessage);
                          setEditDialog(false);
                          fetchFeedbackAnswers();
                        }}
                        messageId={selectedMessage.messageId}
                        chatId={selectedMessage.chatId}
                        orgId={selectedMessage.orgId}
                    />
                    )}   
        </table>
        <div style={{ marginTop: "10px", display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "50px" }}>
          <button style={{}}
          disabled={page === 1} 
          onClick={() => setPage(page - 1)}>
            <FontAwesomeIcon icon={faBackward} />
          </button>

          <span style={{ margin: "0 10px" }}>
            Page {page} of {totalPages}
          </span>

          <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>
            <FontAwesomeIcon icon={faForward} />
          </button>
        </div>
      </div>
    </div>
    </>
  );
}

const styles = {
  heroSection: {
    backgroundColor: "#f9f9f9",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    padding: "6px"
  },
  headerCell: {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#f2f2f2",
  },
  cell: {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "left",
  },
  row: {
    backgroundColor: "#fff",
  },
  noRecordCell: {
    textAlign: "center",
    padding: "10px",
    color: "#888",
  },
  expandCell: {
    backgroundColor: "#fafafa",
    padding: "10px",
    border: "1px solid #ddd",
  },
}

export default KnowledgeFeedback;
